import { FormControl, Grid, TextField, InputLabel, Select } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { init, setEntity, setData, setListPadre, setValidationMessage, activeValidations
  } from "../redux/catalogSlice";
import * as catalogoService from "../services/catalogoService";
import { FormHelperText as HelperText } from '@mui/material';

// Formulario del catalogo. IdPadre apunta a otro catalogo: los grupos son los
// que tienen IdPadre = 0.
const Catalogo = (props) => {
    const isReadOnly = props.isReadOnly;
    const sliceKey = props.sliceKey;
    const params = useParams();
    const dispatch = useDispatch();

    const entity = useSelector((state) => state.catalog[sliceKey]?.entity) || {};
    const listPadre = useSelector((state) => state.catalog[sliceKey]?.listPadre) || [];
    const validate = useSelector((state) => state.catalog[sliceKey]?.validationActive) || {};

    const validation = {
        descripcion: {
            error: !entity.descripcion || entity.descripcion.length < 2,
            message: "Ingrese la descripcion",
        },
        idPadre: {
            error: entity.idPadre == null,
            message: "Seleccione el padre",
        },
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    useEffect(() => {
        dispatch(init({ sliceKey: sliceKey }));
    }, [dispatch, sliceKey])

    const fetchEntity = useCallback(async () => {
        if (!params.id || params.id == 0) return;

        const response = await catalogoService.GetCatalogoById(params.id)
            .catch((err) => { console.log("Err: ", err) });

        if (response) dispatch(setEntity({ sliceKey: sliceKey, data: response }));
    }, [params.id])

    const fetchListPadre = useCallback(async () => {
        const data = await catalogoService.getsCatalogoPadre()
            .catch((err) => { console.log("Err: ", err) });

        dispatch(setListPadre({ sliceKey: sliceKey, data: data || [] }));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListPadre();
    }, [])

    useEffect(() => {
        dispatch(setValidationMessage({ sliceKey: sliceKey, message: messagesValidation() }));
    }, [entity])

    const setDataEntity = e => {
        dispatch(setData({ sliceKey: sliceKey, name: e.target.name, value: e.target.value }));
    }

    const setIdPadre = (event) => {
        const id = parseInt(event.target.value);
        const padre = listPadre.find((row) => row.idCatalogo == id);

        dispatch(setData({ sliceKey: sliceKey, name: "idPadre", value: id }));
        dispatch(setData({ sliceKey: sliceKey, name: "descripcionPadre", value: padre?.descripcion || "" }));
    }

    return (
        <Grid container>
            <Grid container spacing={2} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="codigo"
                        label="Codigo"
                        fullWidth
                        value={entity.codigo || ""}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        name="descripcion"
                        label="Descripcion"
                        fullWidth
                        value={entity.descripcion || ""}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        error={validate.descripcion && validation.descripcion.error}
                        helperText={validate.descripcion && validation.descripcion.error ? validation.descripcion.message : ""}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        name="abreviado"
                        label="Abreviado"
                        fullWidth
                        value={entity.abreviado || ""}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        name="orden"
                        label="Orden"
                        type="number"
                        fullWidth
                        value={entity.orden || 0}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth error={validate.idPadre && validation.idPadre.error}>
                        <InputLabel htmlFor="input-idPadre">Padre</InputLabel>
                        <Select
                            native
                            label="Padre"
                            value={entity.idPadre == null ? 0 : entity.idPadre}
                            onChange={setIdPadre}
                            inputProps={{ name: 'idPadre', id: 'input-idPadre' }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listPadre.filter((row) => row.idCatalogo != entity.idCatalogo).map((row) => (
                                <option key={row.idCatalogo} value={row.idCatalogo}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idPadre && validation.idPadre.error ? validation.idPadre.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="input-estado">Estado</InputLabel>
                        <Select
                            native
                            label="Estado"
                            value={entity.estado || "A"}
                            onChange={setDataEntity}
                            inputProps={{ name: 'estado', id: 'input-estado' }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key="A" value="A">{"Activo"}</option>
                            <option key="I" value="I">{"Inactivo"}</option>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default Catalogo;